import { useMemo } from 'react';
import { DATE_FORMATS, formatters } from 'common';
export const NoDateFallback = '-';
export function formatWithFallback(value, format, toUtc) {
    if (value === null || value === undefined) {
        return NoDateFallback;
    }
    const dateValue = value instanceof Date ? value : new Date(value);
    try {
        return formatters.getDate(dateValue, format, toUtc);
    }
    catch (err) {
        // Should not happen !!
        // Error is thrown when date-fns `format` is unrecognized (fix it)
        console.error('Date format error', err);
        return formatters.getDate(dateValue, DATE_FORMATS.DEFAULT);
    }
}
export const useDateFormat = (value, format, toUtc) => {
    return useMemo(() => {
        return formatWithFallback(value, format, toUtc);
    }, [value, format, toUtc]);
};
